// extracted by mini-css-extract-plugin
export default {"bg":"Mdue19"};